import { colors } from "@/theme/colors";

// Hakina "H" mark — geometric H in slate with a slanted teal accent at the foot
// of the right leg.
export const Logo = ({ size = 40, ...props }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="hakina-logo"
      role="img"
      aria-label="Hakina Safety logo"
      {...props}
    >
      {/* left leg */}
      <rect x="8" y="8" width="9" height="32" rx="2" fill={colors.textPrimary} />
      {/* right leg */}
      <rect x="31" y="8" width="9" height="32" rx="2" fill={colors.textPrimary} />
      {/* crossbar */}
      <rect x="15" y="20" width="18" height="8" fill={colors.textPrimary} />
      {/* slanted teal accent at the bottom of the right leg */}
      <path d="M31 33 L40 26 V38 a2 2 0 0 1 -2 2 H31 Z" fill={colors.teal} />
    </svg>
  );
};
